import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
	selector: 'app-view-coaching-plans',
	templateUrl: './view-coaching-plans.component.html',
	styleUrls: ['./view-coaching-plans.component.scss']
})
export class ViewCoachingPlansComponent implements OnInit {

  @Input() advisor_id: any;
  @Input() action_type: any;

  user_details: any;

  constructor(
    public commonService: CommonService,
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.spinner.show();
    this.user_details = this.storageService.get('user_details');
    // this.getManagePlanSummary();
    this.getAdvisorCoachingPlans();
    this.getStatus();
  }

  advisor_plan_table_data_loaded: boolean = false;
  advisor_plan_table_data: any = [];

  getAdvisorCoachingPlans() {
    this.advisor_plan_table_data_loaded = false;
    this.commonService.getData('/getcoachingplanbyadvisor/?advisor=' + this.advisor_id).subscribe(
      (res: any) => {
        this.advisor_plan_table_data = res['data'];
        this.advisor_plan_table_data_loaded = true;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  status_list: any = [];
  getStatus() {
    this.commonService.getData('/status/?no_page=true').subscribe(
      (res: any) => {
        this.status_list = res;
      },
      (err) => {
        this.commonService.showToast('error', err.error);
      },
    );
  }

  selected_coaching_plan_details: any = {
    name: '',
    id: "",
  };
  selected_coaching_plan_data: any;
  selected_coaching_plan_data_loaded: boolean = false;
  getSelectedCoachingPlanData(data) {
    this.selected_coaching_plan_data_loaded = false;
    this.selected_coaching_plan_details = JSON.parse(JSON.stringify(data));
    // this.commonService.getData('/getselectedadvisorcoachingplanscreen/' + this.selected_coaching_plan_details.name + '/?advisor=' + this.advisor_id).subscribe(
    this.commonService.getData('/getselectedadvisorcoachingplanscreen/' + this.selected_coaching_plan_details.id + '/?advisor=' + this.advisor_id).subscribe(
        (res: any) => {
          this.selected_coaching_plan_data = res;
          this.selected_coaching_plan_data_loaded = true;
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }

  back() {
    this.selected_coaching_plan_details = {
      name: '',
      id: "",
    };
  }

  changeTrainingStatus(training, advisor) {
    const payload = {
      id: training[advisor.id].id,
      status: training[advisor.id].status_id,
    };
    this.commonService
      .patch('/coachingtraining/' + payload.id + '/', payload)
      .subscribe(
        (res: any) => {
          this.commonService.showToast(
            'success',
            'Training Status has been changed successfully.',
          );
        },
        (err) => {
          this.commonService.showToast('error', err.error);
        },
      );
  }
}
